module.exports = __webpack_public_path__ + "assets/img/e913-ro.svg";